import { Box, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { ThinkingTile } from './ThinkingTile';

type Props = {
  content: string;
  thinkingContent?: string;
};

export function SiestaMessage({ content, thinkingContent }: Props) {
  return (
    <Box>
      {thinkingContent && <ThinkingTile content={thinkingContent} />}
      <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.8">
        {content}
      </Text>
    </Box>
  );
}
